import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { Nil } from "cy-util";

// requires flag svg files to be in the below location exposed publically
//
const styles = cva([""], {
  variants: {},
});

export type FlagProps = {
  country: string | Nil;
  aspect: "4x3" | "1x1";
  className?: string;
} & VariantProps<typeof styles>;

export function Flag({ country, className, aspect }: FlagProps) {
  if (!country) {
    return null;
  }
  return (
    <img
      alt={country}
      className={styles({ className })}
      src={`/assets/countries/${aspect}/${country.toLowerCase()}.svg`}
    />
  );
}
